import React from 'react'
import { compose, pure } from 'recompose'
import styles from './gradientHrComponent.scss'
import PropTypes from 'prop-types'

export function GradientHr (props: Props) {
  return <hr className={[styles.gradientHr, props.className].join(' ')} />
}
GradientHr.propTypes = {
  className: PropTypes.string
}

export default compose(pure)(GradientHr)



// WEBPACK FOOTER //
// ./src/components/gradientHr/gradientHrComponent.js